import api from "./api";

export const productsService = {
  list(query, extraParams = {}) {
    const params = { ...extraParams };
    if (query) params.q = query;
    return api.get("/products", { params });
  },
  get(id) {
    return api.get(`/products/${id}`);
  },
  getRubros(params) {
    return api.get("/products/rubros", { params });
  },
  getSubrubros(params) {
    return api.get("/products/subrubros", { params });
  },
  create(payload) {
    return api.post("/products", payload);
  },
  update(id, payload) {
    return api.patch(`/products/${id}`, payload);
  },
  importUtilityCoefficients(formData, params = {}) {
    return api.post("/products/utility-coefficients/import", formData, {
      params,
      timeout: 10 * 60 * 1000,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  uploadImage(id, file) {
    const formData = new FormData();
    formData.append("image", file);
    return api.post(`/products/${id}/image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getImage(id) {
    return api.get(`/products/${id}/image`, { responseType: "blob" });
  },
  deleteImage(id) {
    return api.delete(`/products/${id}/image`);
  },

  getPurchaseOrders(id, params = {}) {
    return api.get(`/products/${id}/purchase-orders`, { params });
  },

  getStockSummary(id) {
    return api.get(`/products/${id}/stock-summary`);
  },
};
